// extracted by mini-css-extract-plugin
export default {"V2Anchor":"V2Anchor--LDDRT","markerAnimationScale":"markerAnimationScale--g59yu"};